import React, { Component } from 'react';
import twitter from '../../assets/images/footer-icons/twitter-icn.svg';
import insta from '../../assets/images/footer-icons/instagram-icon.svg';
import { lang } from '../../lang';
import { withTranslation } from 'react-i18next';
class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        const { t } = this.props;
        return (
            <div className='ace-footer-large ace-footer-hp'>
                {this.props.minimal ? (
                    <>
                        <div className='col'>
                            <div className='row footer-bottom-minimal'>
                                <a
                                    href='https://twitter.com/acesaudiorg'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    <img
                                        src={twitter}
                                        alt='twitter'
                                        className='social-icon'
                                    />
                                </a>
                                <a
                                    href='https://www.instagram.com/acesaudiorg'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    <img
                                        src={insta}
                                        alt='instagram'
                                        className='social-icon'
                                    />
                                </a>
                            </div>
                        </div>
                        <div className='footer-bottom footer-bottom-minimal '>
                            <p className='rights rights-white'>{t('footer.rights')}</p>
                        </div>
                    </>
                ) : (
                    <div className='footer-bottom'>
                        <div className='row'>
                            <div className='col'>
                                <p>{t('footer.rights')}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation()(Footer);
